<template>
  <div>
    <OtpValidation ref="otpValidator" @otp_validated="onOtpValidated" />
    <EventListener
      :events="['password_reset_required']"
      @password_reset_required="onPasswordResetRequired"
    />
  </div>
</template>

<script>
import EventListener from '@/components/utils/EventListener.vue'
import OtpValidation from '../utils/OtpValidation.vue'

export default {
  name: 'homeComponent',
  components: {
    EventListener,
    OtpValidation,
  },
  data() {
    return {}
  },
  mounted() {},
  methods: {
    onPasswordResetRequired({ email, userName }) {
      this.$refs.otpValidator.validateEmail({
        email,
        firstName: userName,
        reason: 'passwordReset',
      })
    },
    async onOtpValidated({ reason }) {
      console.log(reason)
      await new Promise(r => setTimeout(r, 500))
      // if (reason !== 'passwordReset') return
      const prompt = await window.customPrompt({
        title: 'Entre votre nouveau mot de passe',
        formFields: [
          {
            type: 'password',
            propertyName: 'password',
            label: 'Nouveau mot de passe',
            placeHolder: '********',
            defaultValue: '',
            inputProps: {
              minLenght: 6,
            },
            required: true,
            class: 'col-span-12',
          },
          {
            type: 'password',
            propertyName: 'passwordConfirm',
            label: 'Confirmez le mot de passe',
            placeHolder: '********',
            defaultValue: '',
            required: true,
            class: 'col-span-12',
            inputProps: { forceUppercase: false },
            validate(data, form) {
              if (data !== form.password)
                return 'Les mots de passe ne sont pas identique'
              return ''
            },
          },
        ],
        successText: 'Modifier',
      })
      if (!prompt.accepted) return null
      this.$Events.dispatchEvent('update_user_data', {
        password: prompt.data.password,
      })
    },
  },
}
</script>
